export interface FileParseFormatFileExtensionDto {
  FileParseFormatFileExtensionId: Guid;
  FileParseFormatId: Guid;
  FileExtension: string;
}

export class FileParseFormatFileExtensionDto implements FileParseFormatFileExtensionDto {
}